import React from "react";

const ValidateEmail = (props) => (
    <svg
        width={200}
        height={114}
        viewBox="0 0 200 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={200} height={113.735} rx={30} fill="#F0F3F6" />
        <path
            d="M36.1289 15.6611L94.0242 57.3051C97.4973 59.8033 102.175 59.8154 105.661 57.3351L164.233 15.6611"
            stroke="#9EB9CA"
            strokeOpacity={0.5}
            strokeWidth={6}
            strokeLinecap="round"
        />
        <rect
            opacity={0.4}
            x={26.8896}
            y={72.838}
            width={27.0785}
            height={7.15177}
            rx={3}
            fill="#9EB9CA"
        />
        <rect
            opacity={0.4}
            x={26.8896}
            y={85.1935}
            width={20.1202}
            height={7.15177}
            rx={3}
            fill="#9EB9CA"
        />
        <g opacity={0.9}>
            <rect
                x={141.715}
                y={55.5478}
                width={40.4638}
                height={40.4638}
                rx={20.2319}
                fill="#3EC28F"
            />
        </g>
        <g opacity={0.3}>
            <rect
                x={136.551}
                y={50.993}
                width={50.9824}
                height={49.8976}
                rx={24.9488}
                fill="#3EC28F"
            />
        </g>
        <path
            d="M173.569 80.792C173.441 81.0853 173.152 81.2747 172.832 81.275C172.721 81.2753 172.611 81.2523 172.51 81.2074C172.103 81.0294 171.917 80.5555 172.095 80.1483C173.319 77.3301 173.241 74.1158 171.883 71.3595C170.525 68.6033 168.024 66.5834 165.043 65.8363C162.062 65.0893 158.904 65.6909 156.407 67.4811L157.992 67.7322C158.407 67.797 158.702 68.1703 158.67 68.5893C158.637 69.0082 158.288 69.3315 157.868 69.3318C157.825 69.3318 157.783 69.3284 157.74 69.322L154.414 68.7944C154.386 68.7857 154.359 68.7756 154.332 68.7638C154.277 68.7509 154.223 68.7321 154.172 68.7074C154.123 68.6816 154.077 68.651 154.035 68.6156C154.014 68.5991 153.995 68.5814 153.977 68.5626C153.962 68.548 153.957 68.5272 153.943 68.511H153.943C153.907 68.4686 153.876 68.422 153.851 68.3726C153.824 68.3311 153.801 68.287 153.784 68.2407C153.769 68.1919 153.76 68.1417 153.755 68.0912C153.749 68.0376 153.749 67.9837 153.755 67.9301V67.9189V67.8689L154.282 64.5427C154.352 64.1038 154.765 63.8044 155.204 63.8742C155.643 63.9438 155.942 64.3564 155.872 64.7955L155.678 66.0249C157.838 64.5441 160.422 63.8063 163.039 63.923C165.656 64.0398 168.163 65.0049 170.184 66.6723C172.204 68.3398 173.627 70.619 174.237 73.1662C174.848 75.7134 174.613 78.3903 173.569 80.7926L173.569 80.792ZM171.256 83.8303C171.251 83.7795 171.242 83.7293 171.227 83.6805C171.212 83.6347 171.191 83.5904 171.166 83.5486C171.141 83.4992 171.11 83.4529 171.075 83.4102C171.06 83.3942 171.055 83.3732 171.041 83.3586L171.041 83.3589C171.018 83.3418 170.994 83.3261 170.968 83.312C170.926 83.2767 170.88 83.2461 170.832 83.2203C170.783 83.1961 170.731 83.1773 170.679 83.1641C170.652 83.1521 170.625 83.142 170.597 83.1336L167.271 82.6057C166.831 82.5364 166.419 82.8361 166.35 83.275C166.281 83.7142 166.58 84.1261 167.019 84.1954L168.604 84.4465C166.107 86.2363 162.949 86.8374 159.969 86.0907C156.989 85.3437 154.488 83.3243 153.13 80.5687C151.771 77.8127 151.693 74.599 152.917 71.7806C153.01 71.5839 153.019 71.3577 152.943 71.1537C152.867 70.95 152.711 70.7858 152.511 70.6985C152.312 70.6115 152.086 70.609 151.884 70.6915C151.683 70.774 151.523 70.9348 151.443 71.1368C150.396 73.5401 150.161 76.2186 150.772 78.7669C151.383 81.3157 152.807 83.5966 154.829 85.2644C156.851 86.9321 159.361 87.8963 161.98 88.0111C164.598 88.1258 167.183 87.385 169.343 85.9008L169.148 87.1302H169.149C169.115 87.3409 169.167 87.5564 169.293 87.729C169.418 87.9016 169.607 88.0175 169.818 88.0506C169.86 88.0585 169.902 88.0621 169.945 88.0618C170.34 88.0613 170.677 87.7734 170.738 87.3827L171.266 84.0565V84.0066V83.992V83.9922C171.269 83.9384 171.265 83.8845 171.257 83.8312L171.256 83.8303Z"
            fill="white"
        />
    </svg>
);

export default ValidateEmail;
